import { render, staticRenderFns } from "./ProgressBadgeTable.vue?vue&type=template&id=11cfc2d6&scoped=true"
import script from "./ProgressBadgeTable.vue?vue&type=script&lang=ts"
export * from "./ProgressBadgeTable.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBadgeTable.vue?vue&type=style&index=0&id=11cfc2d6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cfc2d6",
  null
  
)

export default component.exports